module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.2979/img/asset-marketplace-themes-2x.png"